import React from 'react';
import { Link } from 'react-router-dom';
import { CloseIcon, BellIcon, ChatIcon, DeleteIcon, SettingsIcon } from "@chakra-ui/icons";
import Logo from "../../assets/img/Excos/president.jpg";

const Sidebar = ({ isOpen, onClose }) => {
    return (
        <div style={styles.sidebar(isOpen)}>
            <div style={styles.sidebarHeader}>
                <img src={Logo} alt="Logo" style={styles.sidebarLogo} />
                <CloseIcon style={styles.closeIcon} onClick={onClose} />
            </div>
            <nav style={styles.sidebarNav}>
            <Link to="/personalized-post" style={styles.sidebarLink}>
                    <BellIcon style={styles.sidebarIcon} />
                    <span>Dashboard</span>
                </Link>
                <Link to="/personalized-post" style={styles.sidebarLink}>
                    <BellIcon style={styles.sidebarIcon} />
                    <span>Personalized Post</span>
                </Link>
                <Link to="/notifications" style={styles.sidebarLink}>
                    <BellIcon style={styles.sidebarIcon} />
                    <span>Notifications</span>
                </Link>
                <Link to="/chat" style={styles.sidebarLink}>
                    <ChatIcon style={styles.sidebarIcon} />
                    <span>Chat</span>
                </Link>
                <Link to="/settings" style={styles.sidebarLink}>
                    <SettingsIcon style={styles.sidebarIcon} />
                    <span>Settings</span>
                </Link>
            </nav>
            <div style={styles.sidebarBottom}>
                <button style={styles.deleteButton}>
                    <DeleteIcon style={styles.buttonIcon} />
                    <span>Delete Account</span>
                </button>
                <button style={styles.logoutButton}>
                    <CloseIcon style={styles.buttonIcon} />
                    <span>Log Out</span>
                </button>
            </div>
        </div>
    );
};

const styles = {
    sidebar: (isOpen) => ({
        position: 'fixed',
        top: 0,
        left: 0,
        width: '250px',
        height: '100%',
        backgroundColor: '#fff',
        boxShadow: '2px 0 5px rgba(0, 0, 0, 0.2)',
        transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',
        transition: 'transform 0.3s ease-in-out',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
    }),
    sidebarHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: '16px',
        borderBottom: '1px solid #ddd',
    },
    sidebarLogo: {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        objectFit: 'cover',
    },
    closeIcon: {
        marginLeft: 'auto',
        cursor: 'pointer',
    },
    sidebarNav: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: '16px',
    },
    sidebarLink: {
        display: 'flex',
        alignItems: 'center',
        padding: '10px 0',
        textDecoration: 'none',
        color: '#333',
        fontSize: '16px',
        fontWeight: '500',
    },
    sidebarIcon: {
        marginRight: '10px',
    },
    sidebarBottom: {
        padding: '16px',
        borderTop: '1px solid #ddd',
        textAlign: 'center',
        marginTop: 'auto',
    },
    deleteButton: {
        backgroundColor: '#f44336',
        border: 'none',
        color: '#fff',
        padding: '10px',
        margin: '5px',
        borderRadius: '4px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    logoutButton: {
        backgroundColor: '#2196F3',
        border: 'none',
        color: '#fff',
        padding: '10px',
        margin: '5px',
        borderRadius: '4px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    buttonIcon: {
        marginRight: '8px',
    }
};

export default Sidebar;
